import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @repo/internal/react/no-class-components */
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(ErrorBoundary, _React$Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var analyticsEvent = this.props.createAnalyticsEvent({
        action: 'handled',
        actionSubject: 'error',
        actionSubjectId: 'remoteModuleErrorBoundary',
        attributes: {
          error: error === null || error === void 0 ? void 0 : error.message,
          errorInfo: errorInfo,
          dimensions: this.props.remotePlugin.dimensions,
          plugin: this.props.remotePlugin.constructor.name
        }
      });
      analyticsEvent.fire(this.props.analyticsChannel);
      if (this.props.onError) {
        this.props.onError(error, errorInfo);
      }
      this.setState({
        hasError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return this.props.fallback ? /*#__PURE__*/React.createElement(React.Fragment, null, this.props.fallback) : null;
      }
      return this.props.children;
    }
  }]);
}(React.Component);
export default withAnalyticsEvents()(ErrorBoundary);